import React from 'react';
import { AwardIcon, CheckIcon, LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { checkoutUrl, included, price, priceBefore, productShortName, totalBonuses, totalVolumes } from '../data/offer';
export function PricingSection() {
  return <section id="pricing" className="scroll-mt-4 bg-navy py-16 sm:py-24" aria-labelledby="pricing-title" data-id="element-177" data-mp="1j9gzgtubtlbh">
      <div className="mx-auto max-w-3xl px-4" data-id="element-178" data-mp="1nbbvbithn6hv">
        <h2 id="pricing-title" className="text-center text-3xl font-extrabold text-white sm:text-4xl" data-id="element-179" data-mp="1ncn1fpaeoqc5">
          Choose your option
        </h2>

        <article className="mt-10 overflow-hidden rounded-2xl border-2 border-gold bg-steel shadow-2xl shadow-black/40" data-id="element-180" data-mp="1x8glruud9o4h">
          <div className="flex items-center justify-between gap-4 border-b border-gold/50 bg-navy-soft px-6 py-4 sm:px-10" data-id="element-181" data-mp="226i58gvpfpgh">
            <span className="inline-flex items-center gap-2 rounded-full bg-mineral px-3 py-1.5 text-[11px] font-extrabold uppercase tracking-[.14em] text-navy" data-id="element-182" data-mp="2wjsdwcd686s">
              <AwardIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-183" data-mp="1mhq1cco5bkhw" /> Main offer
            </span>
            <span className="text-xs font-bold uppercase tracking-[.14em] text-mineral" data-id="element-184" data-mp="1howxdr0i4g6v">50% off today</span>
          </div>
          <div className="p-6 sm:p-10" data-id="element-185" data-mp="1crejdm7mnas0">
            <div className="flex flex-col gap-6 border-b border-white/10 pb-7 sm:flex-row sm:items-end sm:justify-between" data-id="element-186" data-mp="17rs65crstuj7">
              <div data-id="element-187" data-mp="25fsn8iled1bh">
                <h3 className="text-2xl font-extrabold leading-tight text-white" data-id="element-188" data-mp="25e7t2u2zvke5">{productShortName}</h3>
                <p className="mt-2 text-sm text-muted" data-id="element-189" data-mp="20gz70ieq6w7m">
                  All {totalVolumes} volumes + {totalBonuses} exclusive bonuses ready to use in your classroom.
                </p>
              </div>
              <div className="shrink-0 sm:text-right" data-id="element-190" data-mp="1rfht96osj6m3">
                <span className="text-sm text-muted" data-id="element-191" data-mp="k2pjfqib5bhu">
                  Regular price: <span className="line-through decoration-gold" data-id="element-192" data-mp="jzv062b15wq0">{priceBefore}</span>
                </span>
                <p className="mt-1 whitespace-nowrap text-5xl font-extrabold text-mineral" data-id="element-193" data-mp="hhrrou6c8rlk">{price}</p>
                <p className="text-xs font-bold uppercase tracking-[.14em] text-muted" data-id="element-194" data-mp="mguqvxzn03lm">Today · 50% discount</p>
              </div>
            </div>

            <ul className="mt-7 grid gap-2.5 sm:grid-cols-2" data-id="element-195" data-mp="7islrjcyja29">
              {included.map(item => <li key={item} className="flex items-start gap-2.5 text-sm leading-snug text-white" data-id="element-196" data-mp="ch3rpj04t0f7">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-mineral" aria-hidden="true" data-id="element-197" data-mp="3uv3c2kztxs3r" />
                  {item}
                </li>)}
            </ul>

            <Button href={checkoutUrl} target="_blank" rel="noopener noreferrer" arrow className="mt-9 w-full" data-id="element-198" data-mp="3kzjhc1x04zgl">
              Get my teacher ready now
            </Button>

            <div className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-muted" data-id="element-199" data-mp="3by254umpthx6">
              <span className="inline-flex items-center gap-1.5" data-id="element-200" data-mp="3fznazw0u0vxv">
                <LockIcon className="h-4 w-4 text-mineral" aria-hidden="true" data-id="element-201" data-mp="2xb3doznuynig" /> Secure payment
              </span>
              <span className="inline-flex items-center gap-1.5" data-id="element-202" data-mp="2sc9zf50qysh8">
                <ZapIcon className="h-4 w-4 text-mineral" aria-hidden="true" data-id="element-203" data-mp="2se39kuakjutz" /> Instant access
              </span>
              <span className="inline-flex items-center gap-1.5" data-id="element-204" data-mp="31coma8td0fmu">
                <ShieldCheckIcon className="h-4 w-4 text-mineral" aria-hidden="true" data-id="element-205" data-mp="31b58cov6ego8" /> 7-day guarantee
              </span>
            </div>
            <p className="mt-4 text-center text-xs text-muted" data-id="element-206" data-mp="3baw4euzdx3qf">
              You pay in USD. Your payment platform automatically shows the conversion to your local currency.
            </p>
          </div>
        </article>
      </div>
    </section>;
}